import { createFileRoute } from "@tanstack/react-router";
import { canonical } from "@/components/site/site-config";
import { PageHero } from "@/components/site/PageShell";
import { BUSINESS } from "@/components/site/constants";

export const Route = createFileRoute("/terms-and-conditions")({
  head: () => ({
    meta: [
      { title: "Terms and Conditions | Destination Roofing Inc." },
      { name: "description", content: "Terms of use for the Destination Roofing Inc. website and information about our roofing services in Citrus County, FL." },
      { property: "og:title", content: "Terms and Conditions | Destination Roofing Inc." },
      { property: "og:description", content: "Terms of use for Destination Roofing Inc." },
      { property: "og:url", content: canonical("/terms-and-conditions") },
    ],
    links: [{ rel: "canonical", href: canonical("/terms-and-conditions") }],
  }),
  component: TermsAndConditions,
});

function TermsAndConditions() {
  return (
    <>
      <PageHero eyebrow="Legal" title="Terms and Conditions" subtitle="The terms that apply when you use our website." />
      <section className="mx-auto max-w-3xl px-4 py-12 md:py-16 prose prose-slate">
        <p><strong>Effective date:</strong> January 1, 2025</p>

        <h2>About these terms</h2>
        <p>
          These Terms and Conditions ("Terms") govern your use of the Destination Roofing Inc.
          website at destinationroofinginc.com. By using this site you agree to these Terms. If you
          don't agree, please don't use the site.
        </p>

        <h2>About us</h2>
        <p>
          Destination Roofing Inc. is a family-owned roofing contractor serving Citrus County,
          Florida. Florida Roofing Contractor License {BUSINESS.license}. Licensed and insured.
        </p>

        <h2>Estimates and quotes</h2>
        <p>
          Information on this site is provided for general reference. Pricing, timelines, and scope
          of any roofing project are established only in a written estimate or contract that you
          receive from us after an on-site inspection. Nothing on this website is a binding offer.
        </p>

        <h2>Requesting an inspection</h2>
        <p>
          When you submit our inspection request form, you're asking us to contact you about a Free
          Roof Inspection & Estimate. Submitting the form does not create a contract for roofing
          work. Please provide accurate contact and address information so we can reach you.
        </p>

        <h2>Website content</h2>
        <p>
          Photos, text, and other content on this site are the property of Destination Roofing Inc.
          or used with permission. You may view and print pages for personal, non-commercial use.
          Please don't copy, republish, or use our content commercially without written permission.
        </p>

        <h2>Third-party links</h2>
        <p>
          Our site may link to third-party websites. We are not responsible for the content or
          practices of those sites.
        </p>

        <h2>Disclaimer</h2>
        <p>
          The information on this website is provided "as is" without warranty of any kind. We
          make reasonable efforts to keep the site accurate and up to date but do not guarantee
          that it is free of errors or that it will always be available.
        </p>

        <h2>Limitation of liability</h2>
        <p>
          To the fullest extent permitted by law, Destination Roofing Inc. is not liable for any
          indirect, incidental, or consequential damages arising from your use of this website.
        </p>

        <h2>Governing law</h2>
        <p>
          These Terms are governed by the laws of the State of Florida.
        </p>

        <h2>Changes</h2>
        <p>
          We may update these Terms from time to time. The effective date at the top of this page
          will reflect the most recent revision.
        </p>

        <h2>Contact</h2>
        <p>
          Questions? Reach us at <a href={BUSINESS.phoneHref}>{BUSINESS.phone}</a> or{" "}
          <a href={BUSINESS.emailHref}>{BUSINESS.email}</a>.
        </p>
      </section>
    </>
  );
}
